import Box from "@mui/material/Box";
import { setActiveActionCard } from "components/app/App.slice";
import AsyncAutocomplete from "components/common/Autocomplete";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import ActionDetailsDialog from "components/features/ActionCardDetails/ActionDetailsDialog";
import { isEmpty } from "lodash";
import * as React from "react";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { createParamforSearch, getFilteredAssignees, getLoggedInUserDetails } from "utils/CommonFunctions";
import { checkTemplatePlanPayload } from "utils/StoreUtils";
import { responseTypes } from "utils/Types";
import ActionImportDialog from "../ActionCardDetails/ActionImportDialog";
import { CopyToPlan } from "../CopyToPlan";
import CustomPlanCreation from "../CustomPlanCreation";
import {
  deleteActionCardAsync,
  fetchMyPlanDetailAsync,
  markPlanCompleteAsync,
  setIsRedirectFromNotification
} from "../MyPlanDetails/MyPlanDetails.slice";
import PlanDetailDialog from "../PlanAssignment/PlanSelection/PlanDetailDialog";
import ActionCardHelper from "./ActionCardHelper";
import ActionCardDialogsContext from "./Context";

function Dialogs() {
  const param = useParams();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const isActionHighlight = useAppSelector((state: any) => state.myplans?.MyPlans.isActionHighlight);
  const activeCard: any = useAppSelector((state) => state.app.activeActionCard);
  const myPlanDetails: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const allAssigneesData = useAppSelector((state) => state.myPlanDetails.ad);
  const selectedCards: any = useAppSelector((state) => state?.app?.selectedCards);
  const copySectionData = useAppSelector((state) => state.planDetails.copySectionData);
  const [showPreview, setShowPreview] = useState(false);
  const [assigneeVal, setAssigneeVal] = useState<string[]>([]);

  const isMultipleCardsSelected = selectedCards?.cardList.length;
  const planId = activeCard.planId ?? selectedCards.planId;
  const allAssignees = getFilteredAssignees(activeCard.assignee, allAssigneesData);

  const navigate = useNavigate();

  const {
    isOpenAddActionDialog,
    setIsOpenAddActionDialog,
    isOpenDeleteActionDialog,
    setIsOpenDeleteActionDialog,
    isOpenViewActionDialog,
    setIsOpenViewActionDialog,
    isOpenEditActionDialog,
    setIsOpenEditActionDialog,
    isOpenCopyActionDialog,
    isOpenAssigneeDialog,
    setIsOpenAssigneeDialog,
    isOpenImportActionDialog,
    setIsOpenImportActionDialog,
    isOpenPlanDetailDialog,
    isOpenCustomPlanCreateDialog,
    setIsOpenCustomPlanCreateDialog
  } = React.useContext(ActionCardDialogsContext);

  const deleteAction = async () => {
    let props = {};

    if (isMultipleCardsSelected) {
      props = {
        planId: planId,
        sectionId: selectedCards.sectionId,
        cardId: selectedCards?.cardList?.map((el: any) => el.id),
        cardEditable: selectedCards?.cardList?.find((el: any) => el.cardEditable === "N")
      };
    } else {
      props = {
        planId: planId,
        sectionId: activeCard.sectionId,
        cardId: [activeCard.id]
      };
    }
    const response = await dispatch(deleteActionCardAsync({ ...props, dataParams: checkTemplatePlanPayload({}) }));
    if (response?.payload?.status === responseTypes?.success || response?.payload?.status === responseTypes?.deleted) {
      await dispatch(fetchMyPlanDetailAsync({ id: planId, includePropertyInfo: true }));
    }
    setIsOpenDeleteActionDialog(false);
  };

  const assignActionCard = async () => {
    let cardsPayload: any = [];
    if (isMultipleCardsSelected) {
      const cardsList = [...selectedCards.cardList];
      let cardsListAssignee;
      if (assigneeVal) {
        let assignees: string[];
        cardsListAssignee = cardsList.map((el: any) => {
          assignees = el.assignee ? Array.from(new Set([...(el?.assignee || []), ...assigneeVal])) : assigneeVal;
          return { id: el?.id, assignee: assignees };
        });
      }
      cardsPayload = cardsListAssignee;
    } else
      cardsPayload = [
        {
          id: activeCard?.id,
          assignee: assigneeVal
        }
      ];

    const res = await dispatch(
      markPlanCompleteAsync({
        planId: planId,
        type: "bulk_assign",
        isActionHighlight,
        payload: {
          updateType: "UPDATE_ASSIGNEE",
          sections: [
            {
              id: selectedCards.sectionId || activeCard?.sectionId,
              cardModels: cardsPayload
            }
          ]
        }
      })
    );
    if (res?.meta?.requestStatus === "fulfilled") setIsOpenAssigneeDialog(false);
  };

  const redirectToSecId = () => {
    const id = param.id;
    const cardId = param.cardId;
    const segments = location?.pathname?.split("/");
    const path = segments[1];
    if (cardId) navigate(`/${path}/${id}`, { replace: true });
  };

  const showDialog = showPreview ? (
    <ActionDetailsDialog
      open={showPreview}
      isPreview={true}
      setShowPreview={setShowPreview}
      handleClose={() => setIsOpenAddActionDialog(false)}
    />
  ) : (
    <ActionImportDialog
      setShowPreview={setShowPreview}
      open={isOpenImportActionDialog}
      handleClose={() => setIsOpenImportActionDialog(false)}
    />
  );
  return (
    <>
      <ActionCardHelper />
      {isOpenImportActionDialog || showPreview ? showDialog : <></>}
      {(isOpenViewActionDialog || isOpenEditActionDialog) && (
        <ActionDetailsDialog
          isEdit={isOpenEditActionDialog}
          open={isOpenViewActionDialog || isOpenEditActionDialog}
          setOpen={() => setIsOpenViewActionDialog(true)}
          handleClose={() => {
            dispatch(setActiveActionCard({}));
            dispatch(setIsRedirectFromNotification(false));
            setIsOpenEditActionDialog(false);
            setIsOpenViewActionDialog(false);
            redirectToSecId();
          }}
          assigneeList={allAssignees}
        />
      )}

      {isOpenAddActionDialog && (
        <ActionDetailsDialog
          open={isOpenAddActionDialog}
          isNew={true}
          handleClose={() => setIsOpenAddActionDialog(false)}
          assigneeList={[getLoggedInUserDetails()]}
        />
      )}

      {isOpenCopyActionDialog && <CopyToPlan />}

      {isOpenAssigneeDialog && (
        <DialogFormation
          openDialog={isOpenAssigneeDialog}
          handleClose={() => {
            dispatch(setActiveActionCard({}));
            setIsOpenAssigneeDialog(false);
          }}
          subHeading="Action Assignment"
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                onClick={() => {
                  setIsOpenAssigneeDialog(false);
                  dispatch(setActiveActionCard({}));
                }}
                label="Cancel"
              />
              <Button variant="primary" label="Save" onClick={assignActionCard} />
            </div>
          }
        >
          <Box width={"100%"} justifyContent="center">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline} textAlign="left">
              Assign to
            </Typography>
            <AsyncAutocomplete
              assigneeList={allAssignees}
              getUserDetail={(val) => setAssigneeVal(val)}
              placeholder="Search a user"
              searchParams={{ innCode: createParamforSearch(isCorp, myPlanDetails?.innCode) }}
            />
          </Box>
        </DialogFormation>
      )}

      {isOpenDeleteActionDialog && (
        <DialogFormation
          title="Delete Action"
          openDialog={isOpenDeleteActionDialog}
          handleClose={() => {
            dispatch(setActiveActionCard({}));
            setIsOpenDeleteActionDialog(false);
          }}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={() => setIsOpenDeleteActionDialog(false)} />
              <Button label="Proceed" onClick={deleteAction} />
            </div>
          }
        >
          <div className="vertical-center display-col">
            This will permanently delete the Action.
            <Box>Do you wish to proceed?</Box>
          </div>
        </DialogFormation>
      )}

      {isOpenPlanDetailDialog && <PlanDetailDialog />}

      {isOpenCustomPlanCreateDialog && (
        <CustomPlanCreation
          open={isOpenCustomPlanCreateDialog}
          handleCloseDialog={() => setIsOpenCustomPlanCreateDialog(false)}
          actionPayload={isMultipleCardsSelected ? selectedCards?.cardList : !isEmpty(activeCard) ? [activeCard] : null}
          sectionPayload={copySectionData?.sectionPayload}
        />
      )}
    </>
  );
}

export default Dialogs;
